// Generated from SVG to React Component
import React, { SVGProps } from "react";

export const BugSm = ({ color = "black", ...props }: SVGProps<SVGSVGElement>) => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g clip-path="url(#clip0_12312_229)">
            <path d="M6 5.99992V5.33325C6 4.80282 6.21071 4.29411 6.58579 3.91904C6.96086 3.54397 7.46957 3.33325 8 3.33325C8.53043 3.33325 9.03914 3.54397 9.41421 3.91904C9.78929 4.29411 10 4.80282 10 5.33325V5.99992" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.33317 6H10.6665C11.0636 6.59506 11.2938 7.28571 11.3332 8V10C11.3332 10.8841 10.982 11.7319 10.3569 12.357C9.73174 12.9821 8.88389 13.3333 7.99984 13.3333C7.11578 13.3333 6.26794 12.9821 5.64281 12.357C5.01769 11.7319 4.6665 10.8841 4.6665 10V8C4.70589 7.28571 4.9361 6.59506 5.33317 6Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2 8.66675H4.66667" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.3335 8.66675H14.0002" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8 13.3333V9.33325" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2.6665 12.6666L4.89984 11.3333" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.3334 12.6666L11.1001 11.3333" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2.6665 4.66675L5.1665 6.26675" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.3335 4.66675L10.8335 6.26675" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_12312_229">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
